import SkeletonCard from './SkeletonCard';
import SolicitationCard, { SolicitationCardProps } from './SolicitationCard';

export default SolicitationCard;
export { SkeletonCard };
export type { SolicitationCardProps };
